import React from "react";
import { Portfolio } from "../components";

export const PortfolioPage = () => {
  return (
    <div>
      <Portfolio />
    </div>
  );
};
